import { styled } from 'linaria/react';

export const Container = styled('div')`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 0 32px;
	
	@media (max-width: 650px) {
    padding: 0 20px;
	}
`;
